import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { ManageDeliveryService } from '../manage-delivery-request/manage-delivery.service';
import { SharedHelperService } from '../../shared-modals/shared-helper.service';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/shared/shared.service';
import { SharedModalService } from 'src/app/shared-modals/shared-modal.service';

declare var $;

@Component({
  selector: 'app-scan-relance',
  templateUrl: './scan-relance.component.html',
  styleUrls: ['./scan-relance.component.scss'],
})
export class ScanRelanceComponent implements OnInit {
  scanSubscription;
  drivers = [];
  isLoading = false;
  scanned;
  barCode = '';
  secretCode = '';
  requests = [];
  errorPMsg;
  nids = [];
  successSound = new Audio('./../../../../assets/sounds/success.mp3');
  errorSound = new Audio('./../../../../assets/sounds/error.mp3');
  selectedClient;
  barcodeTimeout;
  selectJobInHistoryModal;
  isPdfLoading = false;
  selectedParcel;
  lastKeyTime: number = 0;
  scannerTimeout: any;
  barcode = '';
  currentJobHistory: [];
  selectedJob;

  @ViewChild('layoutScan', { static: false }) yourInput: ElementRef;
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.handleBarcodeScanner(event.key);
  }

  constructor(
    public sharedModalService: SharedModalService,
    private manageDeliveryService: ManageDeliveryService,
    private toaster: ToastrService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  handleBarcodeScanner(input) {
    clearTimeout(this.barcodeTimeout);
    if (input?.length == 1) this.barCode += input;

    this.barcodeTimeout = setTimeout(() => {
      if (this.barCode.length < 5 || this.nids.includes(this.barCode)) {
        this.barCode = '';
        return;
      }

      this.barcode = this.barCode;
      this.barCode = '';
      this.secretCode = '';

      this.getJobByPackingSlip();
    }, 100);
  }

  getJobByPackingSlip(secretCode = null) {
    const body = {
      packId: this.barcode,
      jobType: 'livraison',
    };
    this.selectedJob = null;

    if (secretCode) {
      body['secretCode'] = secretCode;
      delete body.packId;
    }

    if (this.scanSubscription) {
      this.scanSubscription.unsubscribe();
    }

    if (
      !this.nids.includes(body.packId) &&
      (!secretCode || !this.nids.includes(secretCode))
    ) {
      this.relanceJobRequest();
      // this.scanSubscription = this.manageDeliveryService
      //   .getJobByPackingSlip(body)
      //   .pipe(take(1))
      //   .subscribe(
      //     (d) => {
      //       this.requests.unshift(d);
      //       this.nids.unshift(body.packId);
      //       this.barCode = '';
      //       this.successSound.play();

      //       // this.relanceJobRequest();
      //     },
      //     (e) => {
      //       this.barcode = '';
      //       this.errorSound.play();
      //       this.toaster.error(e.error.message, 'Echec');
      //     }
      //   );
    } else {
      $('#exampleModal').modal('hide');
    }
  }

  getWithSpecCode() {
    let body = {
      secretCode: this.secretCode,
    };
    // this.barCode = '';
    console.log('this.secretCode:', this.secretCode);
    if (!this.nids.includes(body.secretCode.split('-')[0]) && this.secretCode) {
      this.relanceJobRequest();
    }
  }

  relanceJobRequest() {
    this.isLoading = true;
    const payload = {
      packId: this.barcode,
    };

    if (this.secretCode) {
      payload['secretCode'] = this.secretCode;
      delete payload.packId;
    }

    this.manageDeliveryService
      .relanceJobRequest(payload)
      .subscribe((d) => {
        this.requests.unshift(d);
        this.successSound.play();
        this.nids.unshift(this.barcode, this.secretCode);
        $('#exampleModal').modal('hide');
        this.barcode = '';
        this.secretCode = '';
        this.isLoading = false;
      })
      .catch((e) => {
        this.barcode = '';
        this.isLoading = false;
        this.errorSound.play();
        this.toaster.error(e.error.message, 'Echec');
      });
  }

  mouseOverZone() {
    this.yourInput.nativeElement.focus();
  }

  openJobHistory(item) {
    this.selectJobInHistoryModal = item;
    $('#history').modal('show');
  }
}
